module.exports = __webpack_public_path__ + "04cdc4288af95ce20514f4c59d07f8ff.pdf";